import { useContext, useMemo } from 'react';

import { getActiveTabId, getFilteredMenuItems } from '../utils';
import { HeaderContextValue } from '../header-context';
export const useActiveTab = () => {
    const { items, pathname } = useContext(HeaderContextValue);
    const filteredItems = useMemo(() => getFilteredMenuItems(items, 'desktop'), [items]);
    const activeTabId = getActiveTabId(filteredItems, pathname);
    return filteredItems.find((item) => item.id === activeTabId);
};
